// extracted by mini-css-extract-plugin
export var text = "_3g-0";